import React, { Component } from 'react';
import { observer, inject } from 'mobx-react/index';
import { observable } from "mobx";
import DataWrapper from '../../../principal/containers/DataWrapper';
import { TabelaBooking } from "../components/TabelaBooking";
import BookingStore from "../stores/BookingStore";
import { Container, Button, Row, Col, Form } from "reactstrap";
import lscache from 'lscache'
import { makePDF,makeBookingPDF } from "../../../../utils/formatar";
import Footer from "../../../comum/components/Footer";
import FooterOptions from '../../../comum/components/FooterOptions';
import IconButton from '../../../comum/components/IconButton';
import { IconeNavio, IconeCaminhao, IconeCarregar } from '../../../comum/components/Icones';
import { createPDFDetalhesAgendamento } from "../../../../utils/pdfDetalhesAgendamento";
import InputFiltro from '../../../comum/components/InputFiltro';
import Card from '../../../comum/components/Card';
import SelectFiltro from '../../../comum/components/SelectFiltro';
import { montarSelectionBooking } from '../../../../utils/formatar'


import _ from 'lodash';

@inject("store")
@DataWrapper
@observer
export class Booking extends Component {

    @observable codigoBooking;

    constructor(props) {
        super(props);

        this.filtrar = this.filtrar.bind(this)

        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.codigoBooking = _.get(this.props.location.state, `codigoBooking`);
        this.codigoContainer = _.get(this.props.location.state, `codigoContainer`);

        //Filtros - tela container
        this.booking = _.get(this.props.location.state, `booking`);
        this.container = _.get(this.props.location.state, `container`);
        this.notaFiscal = _.get(this.props.location.state, `notaFiscal`);

        this.controller = new BookingStore();
    }

    componentWillMount() {
        this.logging = false;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Booking");
        this.appStore.showTopbar(true);
        //this.controller.carregarLista();
        let params = {};

        this.controller.carregarOperacoes();
        if (this.codigoBooking) {
            this.controller.carregarPorCodigo(this.codigoBooking);
            this.controller.carregarLista();
        }

        if (this.codigoContainer) {
            params.state = {
                booking: this.booking,
                container: this.container,
                notaFiscal: this.notaFiscal,
                codigoBooking: this.controller.codigoBooking
            };

            this.appStore.showVoltarTopBar(true, `containers-detalhes/${this.codigoContainer}`, params);

            this.codigoBooking = this.controller.codigoBooking;
        }
        else {
            if (this.appStore.topbarVoltarVisivel === true) {
                this.appStore.showVoltarTopBar(false, "/")
            }
        }
    }

    filtrar() { 
        this.controller.carregarLista() 
    }
    render() {
        return (
            <div>
                <div className="form-wrapper">
                    <Container fluid>
                        <Card className="tabela-container area-form pb-0">
                            <div className="filtros">
                                <Row className="align-items-end">
                                    <InputFiltro titulo="Cód. Booking" className="mb-1" xl={3} sm={6} xs={12}
                                        uppercase={true}
                                        onEnter={() => this.filtrar()}
                                        onChange={(event) => this.controller.carregarPorCodigo(event.target.value)} />

                                    {lscache.get('Perfil').includes('ARMADOR') && <SelectFiltro className="mb-1" titulo="Operação" xl={3} sm={6} xs={12}
                                        itens={this.controller.operacoes}
                                        valor={(this.codigoBooking) ? this.codigoBooking : this.controller.operacoesSelecionado}
                                        itensValor="Viagem" itensLabel="NavioNome"
                                        onChange={(valor) => this.controller.selecionarOperacao(valor)}
                                        options={montarSelectionBooking('Viagem', this.controller.operacoes)}

                                    />}

                                    <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom">
                                        <button onClick={this.filtrar} className="btn-com-bordas-primary btn-filtrar">Filtrar</button>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                        <TabelaBooking controller={this.controller} />
                    </Container>
                    <Footer>
                    <FooterOptions>
                        <div>
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.controller.bookingLista.length===0}
                                onClick={
                                    () => makeBookingPDF(this.controller.bookingLista[0].booking,this.controller.bookingLista[0].itens,this.controller.bookingLista[0].containers)
                                }
                            />
                        </div>
                    </FooterOptions>
                </Footer>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/booking/tela/Booking.js